import script from "./ModuleContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./ModuleContainer.vue?vue&type=script&setup=true&lang=js"

import "./ModuleContainer.vue?vue&type=style&index=0&id=7844eb26&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/set-repository-web-glasses/glasses-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7844eb26"]])

export default __exports__